import React, { useEffect, useMemo, useState } from "react";
import {
  Container,
  Card,
  CardBody,
  Row,
  Col,
  Button,
} from "reactstrap";
import classnames from "classnames";

// flatpickr
import "flatpickr/dist/themes/material_blue.css";
import FlatPickr from "react-flatpickr";

import TableContainer from "./tables/TableContainer";
import "./tables/tableCustom.css";

import axiosInstance from "utils/axiosInstance";
import { format, subHours } from "date-fns";

//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb";
import Spinners from "components/Common/Spinner";
import { handleSearchData } from "components/Common/searchFile";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSyncAlt } from "@fortawesome/free-solid-svg-icons";

const AdminRedemptionPage = ({ t }) => {

  //meta title
  document.title = "點數兌換管理 | TheChart.AI";

  /* ---------------- state ---------------- */
  const [activeTab, setActiveTab] = useState("1");
  const [startDate, setStartDate] = useState(new Date('06-01-2024'));
  
  const [redemptionList, setRedemptionList] = useState([]);
  const [redemptionFilter, setRedemptionFilter] = useState({
    date: null,
    status: "all",
  });
  const [loading, setLoading] = useState(false);


  /* ---------------- data fetch ---------------- */

  const fetchRedemptions = async () => {
    setLoading(true);
    try {
      const res = await axiosInstance.get("/knovia/admin/point-redemptions");
      const data = res.data.map(r => ({
        ...r,
        RequestedAt: format(subHours(new Date(r.requestedAt), 8), "yyyy-MM-dd HH:mm:ss"),
      }));
      setRedemptionList(data);
    } catch (error) {
      console.error("Error fetching redemptions", error);
    } finally {
      setLoading(false);
    }
  };

  const handleStatusChange = async (id, newStatus) => {
    try {
      await axiosInstance.patch(`/knovia/admin/point-redemptions/${id}`, { status: newStatus });
      fetchRedemptions();
    } catch (err) {
      console.error("Error updating status", err);
    }
  };

  useEffect(() => {
    fetchRedemptions();
  }, []);

  const columns = useMemo(() => [
    { header: "用戶", accessorKey: "user", enableColumnFilter: false, enableSorting: true },
    { header: "點數", accessorKey: "points", enableColumnFilter: false, enableSorting: true },
    {
      header: "轉換比例",
      accessorKey: "exchangeRateAtRequest",
      enableColumnFilter: false, 
      enableSorting: true,
      cell: ({ row }) => {
        const rate = row.original.exchangeRateAtRequest;
        return <>{(30 / rate).toFixed(2)} → 1</>;
      }
    },
    { header: "幣別", accessorKey: "currency", enableColumnFilter: false, enableSorting: true },
    { 
      header: "金額", 
      accessorKey: "moneyAmount", 
      enableColumnFilter: false, 
      enableSorting: true,
      cell: ({ row }) => {
        return <>{row.original.moneyAmount.toFixed(2)}</>;
      }
    },
    { header: "方式", accessorKey: "payoutMethod", enableColumnFilter: false, enableSorting: true },
    { header: "狀態", accessorKey: "status", enableColumnFilter: false, enableSorting: true },
    { header: "申請時間", accessorKey: "RequestedAt", enableColumnFilter: false, enableSorting: true },
    {
      header: "操作",
      accessorKey: "actions",
      enableColumnFilter: false, 
      enableSorting: true,
      cell: ({ row }) => {
        const status = row.original.status;
        return status === "pending" ? (
          <>
            <Button
              //size="sm"
              color="success"
              onClick={() => handleStatusChange(row.original._id, "completed")}
              style={{ marginRight: "0.4rem", maxHeight: "30px", padding: "5px 10px", fontSize: "12px" }}
            >
              完成
            </Button>
            <Button
              //size="sm"
              color="danger"
              onClick={() => handleStatusChange(row.original._id, "canceled")}
              style={{ marginRight: "0.4rem", maxHeight: "30px", padding: "5px 10px", fontSize: "12px" }}
            >
              取消
            </Button>
          </>
        ) : (
          <i>已處理</i>
        );
      }
    }
  ], []);

  return (
    <div className="page-content">
      <Container fluid>
        <Card>
          <CardBody>
            <Row className="mb-3">
              <Col>
                <h4 className="card-title">積分兌換申請（管理員）</h4>
              </Col>
              <Col style={{ display: "flex", justifyContent: "flex-end" }}>
                <Button
                  color="primary"
                  onClick={fetchRedemptions}
                  disabled={loading}
                >
                  <FontAwesomeIcon icon={faSyncAlt} /> 重新整理
                </Button>
              </Col>
            </Row>

            <TableContainer
              columns={columns}
              data={redemptionList || []}
              isCustomPageSize={true}
              isPagination={true}
              isGlobalFilter={true}
              pagination="pagination"
              SearchPlaceholder={`${redemptionList.length} 筆兌換申請`}
              paginationWrapper="dataTables_paginate paging_simple_numbers"
              tableClass="table-hover table-nowrap datatable dt-responsive nowrap dataTable no-footer dtr-inline"
              customStyles={{
                verticalAlign: "middle"
              }}
            />
          </CardBody>
        </Card>
      </Container>
    </div>
  );
};

AdminRedemptionPage.propTypes = {};

export default AdminRedemptionPage;







